import { render, staticRenderFns } from "./DownloadMaterialModal.vue?vue&type=template&id=905a9344&"
import script from "./DownloadMaterialModal.vue?vue&type=script&lang=js&"
export * from "./DownloadMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports